// Broadcast when the user mutates the project list (favorite, delete, duplicate, …).
// Passive listeners — e.g. the left-nav My Apps / Favorites count badges — refresh on this
// instead of polling, so counts stay correct without a manual page reload. Fired only on a
// real mutation, never on plain list loads or tab switches.
export const PROJECT_LIST_CHANGED_EVENT = "kuika-project-list-changed";

export const dispatchProjectListChanged = (): void => {
  window.dispatchEvent(new CustomEvent(PROJECT_LIST_CHANGED_EVENT));
};
